import { LoadableComponent } from 'library/loader';
import { ResourcesAreaProps } from './ResourcesArea';

export const ResourcesArea = LoadableComponent<ResourcesAreaProps>({
  loader: () => import(/* webpackChunkName: "ResourcesArea" */'./ResourcesArea').then(mod => mod.ResourcesArea)
});
